import React, { Fragment } from 'react';
import { Box, Button, IconButton, Paper, Typography } from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import PublishOutlinedIcon from '@material-ui/icons/PublishOutlined';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';

interface IFileUploadRowProps {
  inputId: string;
  title: string;
  emptyDescription: React.ReactNode;
  uploadButtonLabel: string;
  fileName: string | null;
  accept?: string;
  disabled?: boolean;
  icon?: React.ReactNode;
  iconBgColor?: string;
  buttonColor?: string;
  onFileSelected: (file: File) => void;
  onFileRemoved: () => void;
}

const FileUploadRow: React.FC<IFileUploadRowProps> = ({
  inputId,
  title,
  emptyDescription,
  uploadButtonLabel,
  fileName,
  accept,
  disabled,
  icon,
  iconBgColor = '#EBF9FA',
  buttonColor = '#37AFAD',
  onFileSelected,
  onFileRemoved
}) => {
  const hasFile = !!fileName;
  const canUpload = !hasFile && !disabled;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files.length > 0 ? e.target.files[0] : null;
    e.target.value = '';
    if (file) onFileSelected(file);
  };

  const description = hasFile ? (
    <span className="d-flex align-items-center">
      <span className="crop mr-2">{fileName}</span>
      <IconButton
        aria-label="delete"
        color="inherit"
        className="text-danger"
        size="small"
        onClick={onFileRemoved}
      >
        <DeleteOutlineTwoToneIcon fontSize="small" />
      </IconButton>
    </span>
  ) : (
    emptyDescription
  );

  return (
    <Paper
      variant="outlined"
      className="p-3 mb-3 d-flex flex-row align-items-center"
      style={{ borderRadius: 8 }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{
          width: 44,
          height: 44,
          borderRadius: 6,
          backgroundColor: iconBgColor,
          marginRight: 16
        }}
      >
        {icon ?? <AddCircleOutlineIcon style={{ color: buttonColor }} />}
      </Box>
      <Box flexGrow={1}>
        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
          {title}
        </Typography>
        <Typography variant="body2" color="textSecondary" component="div">
          {description}
        </Typography>
      </Box>
      <Fragment>
        <input
          accept={accept}
          className="d-none"
          id={inputId}
          onChange={handleChange}
          type="file"
          disabled={!canUpload}
        />
        <label htmlFor={inputId} className="mb-0">
          <Button
            variant="contained"
            color="primary"
            component="span"
            disabled={!canUpload}
            startIcon={<PublishOutlinedIcon />}
            style={{
              textTransform: 'none',
              fontWeight: 600,
              whiteSpace: 'nowrap'
            }}
          >
            {uploadButtonLabel}
          </Button>
        </label>
      </Fragment>
    </Paper>
  );
};

export default FileUploadRow;
